<script>
import useSharedData from "@/use/SharedData";
import useValidation from "@/use/Validation";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import {useContratStore} from "@/stores/Contrat";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const {$route, $refs} = useTools();
        const {getBack} = useSharedMethod();
        const {mxRules} = useValidation();
        const {dialog, loading} = useSharedData();
        const contratStore = useContratStore();
        const contrat = ref({});
        const interimId = ref(null);

        function findById(id) {
            loading.value = true;
            axios.get(`/contrats/${id}`).then((response) => {
                contrat.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function update() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put(`/contrats/leave`, contrat.value, {
                    params: {
                        interimId: interimId.value,
                    },
                }).then((response) => {
                    contratStore.deleteContrat(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        onMounted(() => findById($route.params.id));

        return {
            dialog,
            loading,
            mxRules,
            contrat,
            interimId,
            getBack,
            update
        }

    }
}
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="700"
        scrollable
    >
        <v-card flat>
            <w-toolbar color="red" :title="$t('contrat.termination')"/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row dense>
                            <v-col cols="6">
                                <w-label :label="$t('data_select.CONTRAT_EXIT_RATIONALE')" required/>
                                <w-data-select-autocomplete
                                    v-model="contrat.exitRationaleId"
                                    type="CONTRAT_EXIT_RATIONALE"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('contrat.terminate_date')" required/>
                                <w-date-picker
                                    v-model="contrat.leavingDate"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.description')"/>
                                <w-simple-text-area
                                    v-model="contrat.leavingDescription"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.interim')" :required="contrat.workerHead"/>
                                <str-worker-autocomplete
                                    v-model="interimId"
                                    :rules="contrat.workerHead ? [mxRules.required] : []"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn
                    icon="mdi-domain-remove"
                    :text="$t('contrat.terminate')"
                    :loading="loading"
                    color="red"
                    @press="update"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
